<template>
  <div class="login">
    <el-row style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <el-col :span="15" class="loginWrap">
        <div class="loginbg"></div>
      </el-col>
      <el-col :span="9" class="loginWrap rightWrap">
        <div class="innerWrap">
          <p class="title"><img src="../../assets/img/login/sxy.png"><span>{{$t('login.topTitleLeft')}}</span>{{$t('login.topTitleRight')}}</p>
          <div class="formWrap">
            <!-- 二维码按钮 -->
            <div class="codeWrap">
              <img @click="showQRcode = true" src="../../assets/img/login/cd.png" title="WeChat QRCode">
              <div class="tips">
                <wechatIcon title="" /> <span>WeChat QRCode</span>
              </div>
              <p>{{$t('login.login')}}</p>
            </div>
            <!-- 显示的登录二维码 -->
            <div v-if="showQRcode" class="wechatLogin">
              <i class="el-icon-close" @click="showQRcode = false"></i>
              <div class="codeWrap">
                <div class="qrTitle">{{$t('login.wechatTitle')}}</div>
                <div class="qrCode">
                  erweima
                </div>
              </div>
            </div>
            <!-- 修改密码弹框 -->
            <div v-if="showChangePwd" class="wechatLogin changePwd">
              <i @click="closeChange()" class="el-icon-close"></i>
              <div class="RsetWrap">
                <div class="qrTitle">{{$t('login.RsetMsg')}}</div>
                <div style="margin-top:40px;">
                    <!-- 第一步 -->
                    <el-form @keyup.enter.native="setPwdStep1('setPwdform1')" v-show="setPwdStep" ref="setPwdform1" :model="setPwdform1" :rules="setPwdRules1" label-width="0px">
                      <el-form-item prop="phone">
                        <el-input v-model="setPwdform1.phone" :placeholder="$t('login.placehoder1')">
                          <el-select style="width:100px;" slot="prepend" v-model="setPwdform1.place">
                            <el-option label="+86" value="1"></el-option>
                          </el-select>
                        </el-input>
                      </el-form-item>
                      <el-form-item prop="code">
                        <el-input v-model="setPwdform1.code" :placeholder="$t('login.placehoder3')">
                          <el-button slot="append" @click="getChangeCode()" :disabled="getCodeBtn2">{{codeMsg2}}</el-button>
                        </el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" class="submitBtn" @click="setPwdStep1('setPwdform1')">{{$t('login.next')}}</el-button>
                      </el-form-item>
                    </el-form>
                    <!-- 第二步 -->
                    <el-form @keyup.enter.native="setPwdStep2('setPwdform2')" v-show='!setPwdStep' ref="setPwdform2" :model="setPwdform2" :rules="setPwdRules2" label-width="0px">
                      <el-form-item prop="newPwd">
                        <el-input v-model="setPwdform2.newPwd" type="password" :placeholder="$t('login.placehoder4')">
                          <lockIcon slot="prefix" title="" />
                        </el-input>
                      </el-form-item>
                      <el-form-item prop="checkPwd">
                        <el-input v-model="setPwdform2.checkPwd" type="password" :placeholder="$t('login.placehoder5')">
                          <lockIcon slot="prefix" title="" />
                        </el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button @click="pevBtn" class="previous" icon="el-icon-back"></el-button>
                        <el-button type="primary" class="rsetSubmit" @click="setPwdStep2('setPwdform2')">{{$t('login.okBtn')}}</el-button>
                      </el-form-item>
                    </el-form>
                </div>
              </div>
            </div>
            <!-- tab切换 -->
            <div class="titleTab">
              <div :class="{tabSelect: tabchange}" @click="tabchange = true">{{$t('login.login')}}</div>
              <!-- <div :class="{tabSelect: !tabchange}" @click="tabchange = false">{{$t('login.title2')}}</div> -->
            </div>
            <!-- 账号登录 -->
            <el-form @keyup.enter.native="submitForm('form')" v-show='tabchange' ref="form" class="loginForm" :model="form" :rules="rules" label-width="0px">
                <el-form-item prop="phone">
                  <el-input v-model="form.phone" :placeholder="$t('login.placehoder6')">
                    <i slot="prefix" class="el-icon-mobile-phone"></i>
                  </el-input>
                </el-form-item>
                <el-form-item prop="pwd">
                  <el-input v-model="form.pwd" type="password" :placeholder="$t('login.placehoder2')">
                    <lockIcon slot="prefix" title="" />
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <!-- <div style="text-align:right;">
                    <span class="showChange" @click="showChangePwd = true">{{$t('login.forgetPwd')}}</span>
                  </div> -->
                  <el-button type="primary" class="submitBtn" @click="submitForm('form')">{{$t('login.login')}}</el-button>
                </el-form-item>
            </el-form>
            <!-- 验证码登录 -->
            <el-form @keyup.enter.native="submitPhoneForm('Phoneform')" v-show="!tabchange" ref="Phoneform" class="loginForm" :model="Phoneform" :rules="phoneRules" label-width="0px">
                <el-form-item prop="phone" style="height:40px;">
                  <el-input v-model="Phoneform.phone" :placeholder="$t('login.placehoder1')">
                    <el-select style="width:100px;" slot="prepend" v-model="Phoneform.place">
                      <el-option label="+86" value="1"></el-option>
                    </el-select>
                  </el-input>
                </el-form-item>
                <el-form-item prop="code" style="height:40px;">
                  <el-input v-model="Phoneform.code" :placeholder="$t('login.placehoder3')">
                    <el-button slot="append" :disabled='getCodeBtn' @click="getCodefun()">{{codeMsg}}</el-button>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <div style="text-align:right;">
                    <span class="showChange" @click="showChangePwd = true">{{$t('login.forgetPwd')}}</span>
                  </div>
                  <el-button type="primary" class="submitBtn" @click="submitPhoneForm('Phoneform')">{{$t('login.login')}}</el-button>
                </el-form-item>
              </el-form>
          </div>
        </div>
        <!-- 底部备案链接 -->
        <div class="bottomLink">
          <span>Copyright ©2019 tst-cloud.com</span>
          <a href="http://www.beian.miit.gov.cn/" target="_blank">津ICP备14002507号-5</a>
        </div>
      </el-col>
    </el-row>
    
  </div>
</template>

<script>
import md5 from 'blueimp-md5'
import wechatIcon from "vue-material-design-icons/Wechat.vue"
import lockIcon from "vue-material-design-icons/Lock.vue"
import { Loading } from 'element-ui'
export default {
  name: 'login',
  components: {
    wechatIcon,
    lockIcon
  },
  data () {
    let _this = this
    var checkPhone = (rule, value, callback) =>{
      let reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
      if (reg.test(value)){
      _this.getCodeBtn = false
      callback()
      } else if (!value) {
      _this.getCodeBtn = true
      callback(new Error(_this.$t('login.error1')))
      } else {
      _this.getCodeBtn = true
      callback(new Error(_this.$t('login.error3')))
      }
    }
    var validatePass2 = (rule, value, callback) => {
      let _this = this
      if (value === '') {
      callback(new Error(_this.$t('login.error6')))
      } else if (value !== this.setPwdform2.newPwd) {
      callback(new Error(_this.$t('login.error7')))
      } else {
      callback()
      }
    }
    var checkChangePhone = (rule, value, callback) =>{
      let reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
      if (reg.test(value)){
      _this.getCodeBtn2 = false
      callback()
      } else if (!value) {
      _this.getCodeBtn2 = true
      callback(new Error(_this.$t('login.error1')))
      } else {
      _this.getCodeBtn2 = true
      callback(new Error(_this.$t('login.error3')))
      }
    }
    return {
      form:{
        phone: '',
        pwd: ''
      },
      rules:{
        phone: [
          { required: true, message: this.$t('login.error8'), trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: this.$t('login.error2'), trigger: 'blur' },
          { min: 6, max: 12, message: this.$t('login.error4'), trigger: 'blur' }
        ]
      },
      // 验证码登录
      Phoneform:{
        phone: '',
        place: '1',
        code: ''
      },
      phoneRules:{
        phone: [
          // { required: true, message: this.$t('login.error1'), trigger: 'blur' },
          { validator: checkPhone, trigger: 'change' }
        ],
        code: [
          { required: true, message: this.$t('login.error5'), trigger: 'blur' },
        ]
      },
      // 找回密码第一步
      setPwdform1:{
        phone: '',
        place: '1',
        code: ''
      },
      setPwdRules1:{
        phone: [
          // { required: true, message: this.$t('login.error1'), trigger: 'blur' },
          { validator: checkChangePhone, trigger: 'change' }
        ],
        code: [
          { required: true, message: this.$t('login.error5'), trigger: 'blur' },
        ]
      },
      // 第二步设置密码
      setPwdform2:{
        newPwd: '',
        checkPwd: ''
      },
      setPwdRules2: {
        newPwd:[
          { required: true, message: this.$t('login.error2'), trigger: 'blur' },
          { min: 6, max: 12, message: this.$t('login.error4'), trigger: 'blur' }
        ],
        checkPwd:[
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      // 是否显示二维码
      showQRcode: false,
      // tab切换
      tabchange: true,
      // 找回密码步骤
      setPwdStep: true,
      // 验证码倒计时时间
      codeTime: 60,
      codeMsg: this.$t('login.getMsg'),
      getCodeBtn: true,
      // 获取修改密码的验证码倒计时
      codeTime2: 60,
      codeMsg2: this.$t('login.getMsg'),
      getCodeBtn2: true,
      // 显示隐藏
      showChangePwd: false
    }
	},
  mounted() {
    if (this.$store.state.reloadState === false) {
      this.$store.state.reloadState = true
      this.$parent.reload()
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _this = this
          let loadingInstance = Loading.service({ fullscreen: true })
          this.axios({
            method: 'get',
            url: '/url/loginDashboard',
            params:{
              username: _this.form.phone,
              password: md5(_this.form.pwd),
              language: Number(localStorage.getItem('lang')),
              dashboard:7
            }
          }).then(function(res){
            if (res.data.success === 'false') {
              _this.$message.error(res.data.msg)
            } else {
              _this.$store.commit('login', res.data)
              // _this.getDefaultMachine(res.data.roleId)
              // _this.$router.push({path: '/tv'})
              window.location.href = '/tv'
            }
            loadingInstance.close()
          })
        } else {
          return false
        }
      })
    },
    // 获取机器信息
    getDefaultMachine(data){
      let _this= this
      this.axios({
        method:'get',
        url:'/url/getDashboardDefaultInfo',
        params:{
          roleId:data
        }
      }).then((res)=>{
        if(res.status===200){
          _this.$store.commit('loginId',res.data)
          // window.location.href = '/'
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    // 短信登录获取密码倒计时
    codeTiming(){
      if (this.codeTime === 0) {
        this.codeMsg = this.$t('login.getMsg')
        this.codeTime = 60
        this.getCodeBtn = false
      } else {
        this.getCodeBtn = true
        this.codeTime--
        this.codeMsg = '(' + this.codeTime + 's)'
        setTimeout(this.codeTiming, 1000)
      }
    },
    // 点击获取短信按钮
    getCodefun(){
      let _this = this
      this.getCodeBtn = true
      this.axios({
        method: 'post',
        url: '/url/sendCode',
        params:{
          phoneNum: _this.Phoneform.phone,
          type: 1,
          language: Number(localStorage.getItem('lang'))
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.codeTiming()
        } else {
          _this.getCodeBtn = false
          _this.$message.error(res.data.msg)
        }
      })
    },
    // 短信登录登录按钮
    submitPhoneForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _this = this
          let loadingInstance = Loading.service({ fullscreen: true })
          this.axios({
            method: 'post',
            url: '/url/codeLogin',
            params:{
              phone: _this.Phoneform.phone,
              code: _this.Phoneform.code,
              language: Number(localStorage.getItem('lang'))
            }
          }).then(function(res){
            if (res.data.success === 'false') {
              _this.$message.error(res.data.msg)
            } else {
              _this.$store.commit('login', res.data)
              // _this.$router.push({path: '/tv'})
              window.location.href = '/tv'
            }
            loadingInstance.close()
          })

        } else {
          return false
        }
      })
    },
    // 获取修改密码倒计时
    changeCodeTiming(){
      if (this.codeTime2 === 0) {
        this.codeMsg2 = this.$t('login.getMsg')
        this.codeTime2 = 60
        this.getCodeBtn2 = false
      } else {
        this.getCodeBtn2 = true
        this.codeTime2--
        this.codeMsg2 = '(' + this.codeTime2 + 's)'
        setTimeout(this.changeCodeTiming, 1000)
      }
    },
    // 获取修改密码验证码
    getChangeCode(){
      let _this = this
      this.getCodeBtn2 = true
      this.axios({
        method: 'post',
        url: '/url/sendCode',
        params:{
          phoneNum: _this.setPwdform1.phone,
          type: 2,
          language: Number(localStorage.getItem('lang'))
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.changeCodeTiming()
        } else {
          _this.getCodeBtn2 = true
          _this.$message.error(res.data.msg)
        }
      })
    },
    // 修改密码第一步完成
    setPwdStep1(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _this = this
          let loadingInstance = Loading.service({ fullscreen: true })
          this.axios({
            method: 'post',
            url: '/url/findCode',
            params:{
              phone: _this.setPwdform1.phone,
              code: _this.setPwdform1.code,
              language: Number(localStorage.getItem('lang'))
            }
          }).then(function(res){
            if (res.data.success === 'true') {
              _this.setPwdStep = false
            } else {
              _this.$message.error(res.data.msg)
            }
            loadingInstance.close()
          })
          
        } else {
          return false
        }
      })
    },
    setPwdStep2(formName) {
      // alert(formName)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _this = this
          let loadingInstance = Loading.service({ fullscreen: true })
          this.axios({
            method: 'post',
            url: '/url/changPassword',
            params:{
              phone: _this.setPwdform1.phone,
              password: md5(_this.setPwdform2.newPwd),
              language: Number(localStorage.getItem('lang'))
            }
          }).then(function(res){
            if (res.data.success === 'true') {
              _this.$message({
                message: res.data.msg,
                type: 'success'
              })
              _this.setPwdStep = true
              _this.showChangePwd = false
              _this.resetForm()
            } else {
              _this.$message.error(res.data.msg)
            }
            loadingInstance.close()
          })
        } else {
          return false
        }
      })
    },
    // 找回密码上一步
    pevBtn() {
      this.setPwdStep = true
    },
    // 关闭修改密码
    closeChange(){
      this.getCodeBtn2 = true
      this.showChangePwd = false
      this.resetForm()
    },
    // 重置表单
    resetForm(){
      this.$refs['setPwdform1'].resetFields()
      this.$refs['setPwdform2'].resetFields()
    }
  }
}
</script>
<style scoped>
.login{
  width: 100%;
  height: 100%;
  /* min-height: 700px; */
  background-color:#E7EBF1;
}
.loginbg{
  width: 100%;
  height: 100%;
  background-image: url(../../assets/img/login/bg.jpg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 115%;
  filter: brightness(110%) opacity(80%);
}
.loginbg p{
  visibility: hidden;
}
.loginWrap{
  height: 100%;
}
.rightWrap{
  position: relative;
}
.rightWrap .innerWrap{
  width: 80%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.innerWrap .title{
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  /* width: 400px; */
  margin: 0 auto;
  color: #505050;
  margin-bottom:2.85rem; 
}
.innerWrap .title span{
  color: #6772e5;
}
.innerWrap .title img{
  width: 5rem;
  margin-right: 0.71rem;
  vertical-align: middle;
}
.innerWrap .formWrap{
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.13);
  padding: 10px;
  box-sizing: border-box;
  position: relative;
}
.formWrap .codeWrap img{
  width: 75px;
  height: 75px;
  display: none;
}
.formWrap .codeWrap .tips{
  display: inline-block;
  border-radius: 2px;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.15);
  padding: 0 5px 5px 5px;
  vertical-align: top;
  margin-left: 10px;
  font-size: 12px;
  color: rgba(166, 166, 166, 1);
  display: none;

}
.formWrap .codeWrap .wechat-icon{
  font-size: 22px;
  color: #51c332;
}
.formWrap .codeWrap .tips span{
  display: inline-block;
  vertical-align: bottom;
}
.formWrap .codeWrap p{
  font-weight: bold;
  float: right;
  color: #505050;
}
.formWrap .titleTab{
  width: 80%;
  margin: 2.14rem auto 0;
  overflow: hidden;
}
.formWrap .titleTab div{
  /* width: 50%;
  float: left; */
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 1.07rem;
  margin-bottom: 3.57rem;
  font-size: 1.5rem;
}
.titleTab .tabSelect{
  color: #6772e5;
  border-bottom: 1px solid #6772e5!important;
}
.formWrap .loginForm{
  width: 80%;
  margin: 0 auto;
}
.submitBtn{
  width: 100%;
  line-height: 1.78rem;
  font-size: 1.8rem;
  margin-top: 1.07rem;
}
.wechatLogin{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height:100%;
  background-color: #fff;
  z-index: 10;
}
.wechatLogin .el-icon-close{
  font-size: 30px;
  font-weight: bold;
  color: #999;
  position: absolute;
  top:5px;
  right:5px;
  cursor: pointer;
}
.wechatLogin .codeWrap{
  width: 300px;
  margin: 50px auto 0;
}
.wechatLogin .qrTitle{
  text-align: center;
  font-size: 16px;
  padding: 10px 0;
  color: #6772e5;
  border-bottom: 1px solid #6772e5
}
.changePwd .RsetWrap{
  width: 300px;
  margin: 50px auto 0;
}
.rsetSubmit{
  width: 200px;
  line-height: 25px;
  font-size: 18px;
  margin-top: 30px;
}
.previous{
  width: 90px;
  line-height: 25px;
  font-size: 18px;
}
.showChange{
  color:rgba(103, 114, 229, 1);
  cursor: pointer;
  font-size: 1.5rem;
}
.bottomLink{
  width: 320px;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
}
.bottomLink span{
  margin-right: 10px;
}
.bottomLink a{
  color: rgba(103, 114, 229, 1);
}

</style>
